export default __webpack_public_path__ + "static/media/camera-record.1614a85d.svg";